<div class="radios-group">
	<fieldset>
		<div [ngClass]="{'radios-group--inline' : inline}">
			<app-radio-input
				*ngFor="let option of options; trackBy: trackByRadioId"
				[label]="option.label | ibeadmin | async" [id]="option.id"
				(radioChanged)="onRadioChange($event)"
				[selected]="option.selected" [name]="name">
			</app-radio-input>
		</div>
	</fieldset>
</div>
